'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = Field;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _style = require('../../utils/style');

var _immutable = require('immutable');

var _layout = require('../layout');

var _fieldHint = require('../field-hint');

var _fieldHint2 = _interopRequireDefault(_fieldHint);

var _fieldLabel = require('../field-label');

var _fieldLabel2 = _interopRequireDefault(_fieldLabel);

var _fieldValidations = require('../field-validations');

var _fieldValidations2 = _interopRequireDefault(_fieldValidations);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Basic form field container component
 */
function Field(props) {
  var children = props.children,
      validations = props.validations,
      _props$permissions = props.permissions,
      permissions = _props$permissions === undefined ? [] : _props$permissions,
      label = props.label,
      _props$labelProps = props.labelProps,
      labelProps = _props$labelProps === undefined ? {} : _props$labelProps,
      htmlFor = props.htmlFor,
      _props$required = props.required,
      required = _props$required === undefined ? false : _props$required,
      _props$locked = props.locked,
      locked = _props$locked === undefined ? false : _props$locked,
      _props$centered = props.centered,
      centered = _props$centered === undefined ? false : _props$centered,
      icon = props.icon,
      hint = props.hint,
      hintIcon = props.hintIcon,
      onClick = props.onClick,
      className = props.className,
      labelAction = props.labelAction,
      _props$inline = props.inline,
      inline = _props$inline === undefined ? false : _props$inline,
      labelWidth = props.labelWidth,
      onBlur = props.onBlur,
      _props$controlChildre = props.controlChildren,
      controlChildren = _props$controlChildre === undefined ? true : _props$controlChildre,
      otherProps = (0, _objectWithoutProperties3.default)(props, ['children', 'validations', 'permissions', 'label', 'labelProps', 'htmlFor', 'required', 'locked', 'centered', 'icon', 'hint', 'hintIcon', 'onClick', 'className', 'labelAction', 'inline', 'labelWidth', 'onBlur', 'controlChildren']);


  var hintText = permissions.length > 0 ? permissions[0].message : hint;

  var disabled = permissions.length > 0;

  return React.createElement(
    _layout.Box,
    (0, _extends3.default)({
      className: className,
      onClick: onClick,
      position: 'relative',
      flexDirection: 'column',
      justifyContent: inline ? 'space-between' : 'inherit'
    }, (0, _style.pickStyles)(otherProps)),
    React.createElement(
      _layout.Box,
      {
        flexDirection: inline ? 'row' : 'column',
        justifyContent: labelWidth ? 'flex-start' : 'space-between'
      },
      label ? React.createElement(
        _layout.Box,
        {
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: centered ? 'center' : 'space-between'
        },
        React.createElement(
          _fieldLabel2.default,
          {
            htmlFor: htmlFor,
            required: required,
            locked: locked,
            icon: icon,
            labelProps: labelProps,
            marginBottom: inline ? 0 : 4,
            marginRight: inline ? 8 : 0,
            width: labelWidth
          },
          label
        ),
        labelAction
      ) : null,
      !controlChildren ? children : React.Children.map(children, function (child) {
        return React.cloneElement(child, {
          onBlur: onBlur,
          disabled: child.props.disabled === undefined ? disabled : child.props.disabled,
          editable: child.props.editable === undefined ? !disabled : child.props.editable,
          readonly: child.props.readonly === undefined ? disabled : child.props.readonly
        });
      })
    ),
    !!validations ? React.createElement(_fieldValidations2.default, { centered: centered, validations: validations }) : hintText ? React.createElement(_fieldHint2.default, { hint: hintText, icon: hintIcon ? hintIcon : undefined }) : null
  );
}


//////////////////
// WEBPACK FOOTER
// ./~/@kalo/ui/lib/components/field/field.js
// module id = 319
// module chunks = 114276838955818